import { useState, useEffect, useRef } from 'react';

/**
 * Custom hook to load an image for use with react-konva.
 * Returns [image, status] where image is an HTMLImageElement.
 */
export default function useImage(url, crossOrigin) {
  const [image, setImage] = useState(null);
  const imageRef = useRef(null);

  useEffect(() => {
    if (!url) { setImage(null); return; }
    const img = new window.Image();
    if (crossOrigin) img.crossOrigin = crossOrigin;
    img.src = url;
    img.onload = () => { imageRef.current = img; setImage(img); };
    img.onerror = () => setImage(null);
    return () => { img.onload = null; img.onerror = null; };
  }, [url, crossOrigin]);

  return [image];
}
